import { Title } from '@angular/platform-browser';
import { SettingsService } from './../../../settings/settings.service';
import { DevTooltipCustComponent } from './../../../../widgets/dev-tooltip-cust/dev-tooltip-cust.component';
import { AppDevNotifyComponent } from './../../../../widgets/dev-notify-bar/dev-notify-bar.component';
import { ForecastService } from './../../forecast.service';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { DxChartComponent, DxRangeSelectorComponent, DxSelectBoxComponent, DxDataGridComponent, DxTextBoxComponent } from "devextreme-angular";
import {
	FieldDynamicObject, CurrentValidation, MasterTableData, ElementNames, DeepDiveForecastSeasonalityChart,
	DeepDiveForecastDevelopmentNewChart, ForecastElementUpdateNewData, DeepDiveUpdateCommentNew
} from 'src/app/models/forecast/fc-deepdive-models';
import { UtilsService } from './../../../../services/utils.service';
import { ActivatedRoute, Data } from '@angular/router';
import { Location } from '@angular/common';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LoginResult } from 'src/app/models/login-result';
import { AutocompleteComponent } from 'src/app/widgets/autocomplete/autocomplete.component';
import { Task } from '../../../task/task.service';
import { SelectStatementCaption, ForecastOverviewTableData, SettingValue } from 'src/app/models/forecast/fc-overview-models';
import { GridHelper } from 'src/app/helpers/grid-helper';
import { GlobalConstants } from 'src/app/common/global-constants';
import DataSource, { Options } from "devextreme/data/data_source";
import { FileExportService } from 'src/app/common/file-export-service';
import { CanDeactivateService } from 'src/app/models/UnsavedData/UnsavedData';
import { ShareDataService } from 'src/app/services/share-data.service';
import { SortDescriptor } from 'devextreme/data';
import { FcvalidationlogService } from '../../fcvalidationlog.service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { firstValueFrom } from 'rxjs';
import { DxDataGridBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/dx-data-grid-bookmark-elements.operator';
import Globalize from "globalize";
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';
import { DxChartBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/dx-chart-bookmark-elements.operator';
import { LegendClickEvent } from 'devextreme/viz/chart_types';

@Component({
	selector: 'app-deepdive-v1',
	templateUrl: './deepdive-v1.component.html',
	styleUrls: ['./deepdive-v1.component.scss'],
	standalone: false
})
export class DeepdiveV1Component implements OnInit {

	//Grid Variables
	productsDataSource: any = {};
	selectedProductId = '';
	popupVisible = false;
	//Default data settings
	ForecastObjectClientID = null;
	type = "reload";
	loadEventTrk = "PageLoad";
	RoundOffNumber = 0;
	ClientResponsLogic = "Others";
	selectedItem = '';
	//chart value range
	visualRange: any = {};
	currentValidationId: string = '';
	isGridColumnInit = true;
	DisplayMinRoundingPlacesFc = 4;
	DisplayMinRoundingBelowNumberFc = 10;
	//default data initialization
	forecastDevelopmentChartSource: DeepDiveForecastDevelopmentNewChart[];
	yearOnYearChartDataSource: any = [];
	seasonalityChartDataSource: DeepDiveForecastSeasonalityChart[];
	masterTableDataSource: MasterTableData[];
	CurrentValidationData: CurrentValidation;
	FieldDynamicObjectData: FieldDynamicObject;
	forecastElementAddonsNames: ElementNames[];
	forecastElementBasicNames: ElementNames[];
	settingValue: SettingValue[];
	forecastElementAddonsData: any = [];
	//new data
	forecastElementBasicData: any = [];
	forecastElementBasicDataCopy: any = [];
	//get modify by from old data
	forecastElementBasicOldData: any = [];
	forecastClientResponsData: any = [];
	forecastCommentData: any = [];
	forecastCommentElemtData: any = [];
	forecastChartCaption: any = [];
	FinalForecast1Caption = "Perito Forecast";
	FinalForecast3Caption = "Forecast Final";

	deepdiveNewFieldCaption: any = [];
	// Task data
	tasks: Task[] = [];
	showTasksPopup = false;
	showAddTaskPopup = false;
	currentUrl = '';
	activeTasksForCurrentPage = false;
	activeTasks: Task[] = [];

	// Table data
	tableColumnsDataSource: SelectStatementCaption[] = [];
	tableValuesDataSource: any[] = [];
	selectedFcTableRecords: ForecastOverviewTableData[] = [];
	changedFcTableRecords: ForecastOverviewTableData[] = [];
	issueResponsesDataSource: string[] = [];
	showInfoPopup = false;
	infoPopupMessage = '';
	unsavedChanges = false;
	fitTableToPage = false;
	anyActiveFilters = false;
	infPopupTitle = '';
	changeLayoutDeepDive = -1;

	FullName = "";

	//default parameters
	isShowReset = true;
	gridColumns: any[] = [];
	products: any = {};
	//ProductImage
	ProductImageHeight: any;
	ProductImagePath: any;
	ProductImageWidth: any;
	imgSrc: string;
	ImgTitle: string;
	//Key Figure For updating ForecastKeyFigure4IncludeDeepDive
	ForecastKeyFigures = [
		{ FieldName: 'ForecastKeyFigure1IncludeDeepDive', Caption: 'ForecastKeyFigure1', ColumnName: 'ForecastKeyFigure1', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure2IncludeDeepDive', Caption: 'ForecastKeyFigure2', ColumnName: 'ForecastKeyFigure2', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure3IncludeDeepDive', Caption: 'ForecastKeyFigure3', ColumnName: 'ForecastKeyFigure3', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure4IncludeDeepDive', Caption: 'ForecastKeyFigure4', ColumnName: 'ForecastKeyFigure4', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure5IncludeDeepDive', Caption: 'ForecastKeyFigure5', ColumnName: 'ForecastKeyFigure5', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure6IncludeDeepDive', Caption: 'ForecastKeyFigure6', ColumnName: 'ForecastKeyFigure6', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure7IncludeDeepDive', Caption: 'ForecastKeyFigure7', ColumnName: 'ForecastKeyFigure7', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure8IncludeDeepDive', Caption: 'ForecastKeyFigure8', ColumnName: 'ForecastKeyFigure8', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure9IncludeDeepDive', Caption: 'ForecastKeyFigure9', ColumnName: 'ForecastKeyFigure9', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure10IncludeDeepDive', Caption: 'ForecastKeyFigure10', ColumnName: 'ForecastKeyFigure10', Visible: false, Editable: false }
	];

	//Auto Complete variables
	autoCompleteProductDataSource: string[] = [];

	UpdateForecastElemtndata: any = [];
	UploadForestElemt: ForecastElementUpdateNewData;
	startChartValue = { startValue: 0 };

	selectedEsoProduct = '';
	selectedPage = '';
	mainchartTitle = "Monthly";

	//Forecast Seasonality Grph enable disable contain
	EnableDisableForecastSeasonalityActual1 = true;
	EnableDisableForecastSeasonalityActual2 = true;
	EnableDisableForecastSeasonalityActual3 = true;
	EnableDisableForecastSeasonalityForecastFinal3 = true;
	EnableDisableForecastSeasonalityMin = true;
	EnableDisableForecastSeasonalityMax = true;

	//dev express setting changes function for chart need on resize after windows size changes
	@ViewChild("forecastDevelopmentChart", { static: false }) dxForecastDevelopmentChart: DxChartComponent;
	@ViewChild("seasonalityChart", { static: false }) dxSeasonalityChart: DxChartComponent;
	@ViewChild("yearOnYearChart", { static: false }) dxYearOnYearChart: DxChartComponent;
	@ViewChild("forecastDevelopmentRangSelct", { static: false }) forecastDevelopmentRangSelct: DxRangeSelectorComponent;

	@ViewChild("forecastComment", { static: false }) forecastComment: DxSelectBoxComponent;
	@ViewChild("forecastClientOtherComment", { static: false }) forecastClientOtherComment: DxTextBoxComponent;

	@ViewChild("forecastResponse", { static: false }) forecastResponse: DxSelectBoxComponent;

	// update comment
	Updateesponsdata: DeepDiveUpdateCommentNew = new DeepDiveUpdateCommentNew();

	currentComment: any = { Period: 0, Comment: "" }
	@ViewChild('autocomplete')
	autocomplete: AutocompleteComponent;
	SettingDecimal: any;
	//Multiple Factor to dive value of table
	MultipleFactor = 1;
	captionActionResponse = "Client Response"
	captionActioncomment = "Client Comment"
	ImageInfoPopup: boolean;

	gridInitStateSet = false;
	lastUpdatedAt: Date;
	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;

	@ViewChild('dataGrid', { static: false })
	public dataGrid: DxDataGridComponent;

	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);

	public bookmarkElementsOperators: BookmarkElementsOperator[];
	isLoading: boolean = false;
	gridFilterState: any;
	headerFiltersState: any = {};
	filterRowState: {};

	public async initializeBookmarks(): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);

		this.bookmarkElementsOperators = [
			new DxDataGridBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxDataGridBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
				() => this.dataGrid
			),
			new DxChartBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxChartBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
				() => this.dxForecastDevelopmentChart
			)
			,
			new DxChartBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxChartBookmarkElementsOperator.DEFAULT_ID_PART + 1).toString(),
				() => this.dxSeasonalityChart
			),
			new DxChartBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxChartBookmarkElementsOperator.DEFAULT_ID_PART + 2).toString(),
				() => this.dxYearOnYearChart
			)
		];

		return routeData;
	}

	// constructor for loading services
	//constructor(private forecastService: ForecastService) { }
	constructor(
		private fcvaldataservice: FcvalidationlogService,
		private forecastService: ForecastService,
		private route: ActivatedRoute,
		private location: Location,
		private localStorageService: LocalStorageService,
		private settingsService: SettingsService,
		private titleService: Title,
		private fileExportService: FileExportService,
		private activeService: CanDeactivateService,
		private sharedDataService: ShareDataService,
		private _loadingIndicationService: LoadingIndicationService
	) {
		this.titleService.setTitle("Deep Dive");

		let userInfo = this.localStorageService.get<LoginResult>(LoginResult.storage_key);
		this.FullName = userInfo.firstName + " " + userInfo.lastName;
	}

	async ngOnInit() {
		this.currentUrl = this.location.path();



		await this.initializeBookmarks();

		this.LoadDefaultDdl();
		this.initProductId('pageload');
		this.WebSettingsPivot();
		this.SettingsGroupByName();
		this.GetSettingsData();
		this.GetCaption();
	}
	GetCaption() {
		this.fcvaldataservice.getCaptionbyAction('ForecastClientCaption', { showLoadingIndicator: false }).subscribe((data) => {
			if (data != null && data.find(x => x.name == 'ClientResponse') != null && data.find(x => x.name == 'ClientResponse').value != null) {
				this.captionActionResponse = data.find(x => x.name == 'ClientResponse').value;
			}
			if (data != null && data.find(x => x.name == 'Clientcomment') != null && data.find(x => x.name == 'Clientcomment').value != null) {
				this.captionActioncomment = data.find(x => x.name == 'Clientcomment').value;
			}
		})
	}
	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportForecastDeepdivelist", { showLoadingIndicator: false }).subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err, "err");
		});
	}
	SettingsGroupByName() {
		this.settingsService.SettingsGroupByName("FcDeepDive", "ForecastCurrencyField", { showLoadingIndicator: false }).subscribe(result => {
			this.SettingDecimal = result.table;
		});
	}

	handleChartsAndLegends() {
		//caption
		for (let itemCaption = 0; itemCaption < this.forecastChartCaption.length; itemCaption++) {
			if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.series != null
				&& Array.isArray(this.dxForecastDevelopmentChart.series) && this.dxForecastDevelopmentChart.series.length > 0) {
				for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {

					if (this.dxForecastDevelopmentChart.series[index].valueField != null
						&& (this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() == this.forecastChartCaption[itemCaption].fieldName.toLowerCase()
							|| this.dxForecastDevelopmentChart.series[index].name.toLowerCase() == this.forecastChartCaption[itemCaption].fieldName.toLowerCase())

					) {
						this.dxForecastDevelopmentChart.series[index].name = this.forecastChartCaption[itemCaption].captionName;
					}

					if (this.forecastChartCaption[itemCaption].fieldName.toLowerCase() == "finalforecast1"
						&& this.forecastChartCaption[itemCaption].captionName.toLowerCase() != "") {
						this.FinalForecast1Caption = this.forecastChartCaption[itemCaption].captionName;
					}
					if (this.forecastChartCaption[itemCaption].fieldName.toLowerCase() == "finalforecast3"
						&& this.forecastChartCaption[itemCaption].captionName.toLowerCase() != "") {
						this.FinalForecast3Caption = this.forecastChartCaption[itemCaption].captionName;
					}
				}
			}

			if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.series != null
				&& Array.isArray(this.dxSeasonalityChart.series) && this.dxSeasonalityChart.series.length > 0) {
				for (let index = 0; index < this.dxSeasonalityChart.series.length; index++) {
					if (this.dxSeasonalityChart.series[index].valueField != null
						&& (this.dxSeasonalityChart.series[index].valueField.toLowerCase() == this.forecastChartCaption[itemCaption].fieldName.toLowerCase()
							|| this.dxSeasonalityChart.series[index].name.toLowerCase() == this.forecastChartCaption[itemCaption].fieldName.toLowerCase())) {
						this.dxSeasonalityChart.series[index].name = this.forecastChartCaption[itemCaption].captionName;
					}
					this.dxSeasonalityChart.series[index].visible = true;
				}
			}


			if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.series != null
				&& Array.isArray(this.dxYearOnYearChart.series) && this.dxYearOnYearChart.series.length > 0) {
				for (let index = 0; index < this.dxYearOnYearChart.series.length; index++) {
					if (this.dxYearOnYearChart.series[index].valueField != null &&
						(this.dxYearOnYearChart.series[index].valueField.toLowerCase() == this.forecastChartCaption[itemCaption].fieldName.toLowerCase()
							|| this.dxYearOnYearChart.series[index].name.toLowerCase() == this.forecastChartCaption[itemCaption].fieldName.toLowerCase())
					) {
						this.dxYearOnYearChart.series[index].name = this.forecastChartCaption[itemCaption].captionName;
					}
					this.dxYearOnYearChart.series[index].visible = true;
				}
			}

		}

		//dynamic feild setting ForecastKeyFigure
		let VisibleElements = [];
		if (this.settingValue != null && this.settingValue != undefined) {
			this.settingValue.forEach(settingItem => {

				if (settingItem.name.toLowerCase().includes("enabledisable")) {
					let ElementNameEnable = settingItem.name.toLowerCase();
					ElementNameEnable = ElementNameEnable.replace("enabledisable", "");
					if (settingItem.value.toLowerCase() == "no") {
						VisibleElements.push({ visible: false, showInLegend: true, SeriesName: ElementNameEnable });
					}
				}
				if (settingItem.name.toLowerCase().includes("enable")) {
					let ElementName = settingItem.name.toLowerCase();
					ElementName = ElementName.replace("forecastmainchart", "").replace("enable", "");
					if (settingItem.value.toLowerCase() == "yes") {
						VisibleElements.push({ visible: true, showInLegend: true, SeriesName: ElementName });
					}
					else if (settingItem.value.toLowerCase() == "no") {
						VisibleElements.push({ visible: false, showInLegend: false, SeriesName: ElementName });
					}
				}

				//EnableNegativeForecast
				if (settingItem.name == "EnableNegativeForecast" && settingItem.value && settingItem.value == 'yes') {
					this.startChartValue = null;
				}

				//Enable Disable Forecast Seasonality
				if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalityactual1")) {
					if (settingItem.value.toLowerCase() == "no") {
						this.EnableDisableForecastSeasonalityActual1 = false;
					}
				}
				if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalityactual2")) {
					if (settingItem.value.toLowerCase() == "no") {
						this.EnableDisableForecastSeasonalityActual2 = false;
					}
				}
				if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalityactual3")) {
					if (settingItem.value.toLowerCase() == "no") {
						this.EnableDisableForecastSeasonalityActual3 = false;
					}
				}
				if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalityforecastfinal3")) {
					if (settingItem.value.toLowerCase() == "no") {
						this.EnableDisableForecastSeasonalityForecastFinal3 = false;
					}
				}
				if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalitymin")) {
					if (settingItem.value.toLowerCase() == "no") {
						this.EnableDisableForecastSeasonalityMin = false;
					}
				}
				if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalitymax")) {
					if (settingItem.value.toLowerCase() == "no") {
						this.EnableDisableForecastSeasonalityMax = false;
					}
				}

			});
		}

		if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.series != null
			&& Array.isArray(this.dxForecastDevelopmentChart.series) && this.dxForecastDevelopmentChart.series.length > 0) {
			for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {

				//emable/disbale
				if (this.dxForecastDevelopmentChart.series[index].valueField != null) {

					let ElemntExists = VisibleElements.filter(x =>
						x.SeriesName == this.dxForecastDevelopmentChart.series[index].name.toLowerCase() ||
						x.SeriesName.replace("forecast", "") == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() ||
						x.SeriesName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase());
					if (ElemntExists != null && ElemntExists.length > 0) {
						if (ElemntExists.length > 1) {
							if (!ElemntExists[0].visible || !ElemntExists[1].visible) {
								this.dxForecastDevelopmentChart.series[index].visible = false;
							}
							else {
								this.dxForecastDevelopmentChart.series[index].visible = true;
							}

							if (!ElemntExists[0].showInLegend || !ElemntExists[1].showInLegend) {
								this.dxForecastDevelopmentChart.series[index].showInLegend = false;
							}
							else {
								this.dxForecastDevelopmentChart.series[index].showInLegend = true;
							}
						}
						else {
							this.dxForecastDevelopmentChart.series[index].visible = ElemntExists[0].visible;
							this.dxForecastDevelopmentChart.series[index].showInLegend = ElemntExists[0].showInLegend;
						}
					}
					else {
						if (!this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes("addon")
							&& !this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes("actual1")
							&& !this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes("actual2")
							&& !this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes("actual3")
						) {
							this.dxForecastDevelopmentChart.series[index].visible = true;
							this.dxForecastDevelopmentChart.series[index].showInLegend = true;
						}

					}
				}

				if (this.settingValue != null && this.settingValue.length > 0) {
					this.settingValue.forEach(settingItem => {

						if (settingItem.name.toLowerCase().includes("color")) {
							let ElementName = settingItem.name.toLowerCase();
							ElementName = ElementName.replace("color", "");
							if (ElementName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() && settingItem.value != "") {
								this.dxForecastDevelopmentChart.series[index].color = settingItem.value;
							}
						}

						if (settingItem.name.toLowerCase().includes("charttype")) {
							let ElementName = settingItem.name.toLowerCase();
							ElementName = ElementName.replace("charttype", "");
							if (ElementName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() && settingItem.value != null && settingItem.value != "") {
								let chartTypes = settingItem.value.split('-');
								if (chartTypes.length > 0) {
									this.dxForecastDevelopmentChart.series[index].type = chartTypes[0];
								}
								if (chartTypes.length > 1) {
									this.dxForecastDevelopmentChart.series[index].dashStyle = chartTypes[1];
								}
							}

						}

					});
				}
			}
		}

		if (this.dxForecastDevelopmentChart && this.dxForecastDevelopmentChart.instance) { this.dxForecastDevelopmentChart.instance.refresh(); }
		if (this.dxSeasonalityChart && this.dxSeasonalityChart.instance) { this.dxSeasonalityChart.instance.refresh(); }
		if (this.dxYearOnYearChart && this.dxYearOnYearChart.instance) { this.dxYearOnYearChart.instance.refresh(); }
		if (this.forecastDevelopmentRangSelct && this.forecastDevelopmentRangSelct.instance) { this.forecastDevelopmentRangSelct.instance.render(); }
	}

	getOverviewTableDataById(action) {
		try {
			let $this = this;
			let data = [];
			data.push({ settingId: 0, fieldValue: this.ForecastObjectClientID });
			this.forecastService.GetDeepDiveTableById(null, null, 12, null, data, { showLoadingIndicator: false }).subscribe(result => {

				if (result != null && result.data != null && result.data.length > 0) {
					result.data[0].productId = result.data[0].ForecastObjectClientId;
					if ($this.products != null) {
						let prodct1 = $this.products.findIndex(x => x.ForecastObjectClientId == this.ForecastObjectClientID);
						if (prodct1 != null && prodct1 > -1) {
							$this.products[prodct1] = result.data[0];
						}
						let prodct2 = $this.tableValuesDataSource.findIndex(x => x.ForecastObjectClientId == this.ForecastObjectClientID);
						if (prodct2 != null && prodct2 > -1) {
							$this.tableValuesDataSource[prodct2] = result.data[0];
							if (this.IsSaveNext) {
								this.getProductData(this.IsSaveItem);
								this.IsSaveNext = false;
							}
						}
					}
				}
				else {
					if (this.IsSaveNext) {
						this.getProductData(this.IsSaveItem);
						this.IsSaveNext = false;
					}
				}
			});
		} catch (e) {
			console.log(e);
		}
	}

	getOverviewTableData(action) {
		let filterExpr = [];
		let sortingExpres: SortDescriptor<any> | SortDescriptor<any>[] = [];

		const $this = this;
		if (action == 'reload' && this.dataGrid) {
			//Getting all Filtering
			if (this.dataGrid.instance != null && this.dataGrid.instance.getCombinedFilter(true) != null) {

			}

			//Getting all sorting
			if (this.dataGrid.instance != null && this.dataGrid.instance.getDataSource().sort() != null) {

			}

		}

		this.forecastService.getDeepDiveTableData(null, null, 12, null, null, { showLoadingIndicator: false }).subscribe(result => {
			this.isLoading = false;
			$this.tableColumnsDataSource = [];
			if (result != null && result.columns != null) {
				for (let i = 0; i < result.columns.length; i++) {
					let dataTypeValue = "string";
					if (this.SettingDecimal != null && this.SettingDecimal.length > 0) {
						let itemFilter = this.SettingDecimal.find(x => x.name == result.columns[i].columnName);
						if (itemFilter != null) {
							dataTypeValue = "number";
						}
					}

					$this.tableColumnsDataSource.push({
						caption: result.columns[i].caption,
						columnName: result.columns[i].columnName,
						dataType: dataTypeValue
					})
				}
			}

			$this.tableValuesDataSource = result.data;

			// if (this.dataGrid && this.gridFilterState) {
			// 	this.dataGrid.instance.filter(this.gridFilterState);
			//}

			$this.products = result.data;
			setTimeout(() => $this.restoreFilterUIState($this), 10);

			if (action != 'reload') {
				$this.getSearchDataSource('', false);
				if (this.route.snapshot.queryParamMap.get("id")) {
					const productId = this.route.snapshot.queryParamMap.get("id");

					this.changeProductId({ data: { ForecastObjectClientId: productId } });
				}
			}

			setTimeout(() => {
				this.bookmarksGroup.applyDefaultBookmark();
			}, 0);

		});

		if (action != 'reload') {
			this.forecastService.getIssueResponseDatasource({ showLoadingIndicator: false }).subscribe(result => {
				this.issueResponsesDataSource = result.map(x => x.listElement);
			});
		}
	}


	changeFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	gridRowUpdated(e) {
		// this.unsavedChanges = true;
		// this.addOrReplace(e.data);
	}

	arrIndex = {};
	addOrReplace(object) {
		let index = this.changedFcTableRecords.findIndex((item: any) => item.productId === object.productId);
		if (index === -1) {
			this.changedFcTableRecords.push(object);
		} else {
			this.changedFcTableRecords[index] = object;
		}
	}

	gridSelectionChanged(data: any) {
		this.selectedFcTableRecords = [];

		data.selectedRowKeys.forEach(element => {
			if (!this.selectedFcTableRecords.includes(element)) {
				this.selectedFcTableRecords.push(element);
			}
		});
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;

		toolbarItems.unshift({
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		}, {
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}, {
			location: 'before',
			template: 'saveButtonTemplate'
		}, {
			location: 'before',
			template: 'undoButtonTemplate'
		}, {
			location: 'before',
			template: 'bookmarkButtonTemplate'
		});
	}

	canEdit(item: any): boolean {
		const dataField = item.column.dataField;
		const correspondingColumn = this.tableColumnsDataSource.find(x => x.columnName === dataField);

		if (correspondingColumn && (correspondingColumn.columnName === 'PermanentComment' || correspondingColumn.columnName === 'IssueResponse')) {
			return true;
		}

		return false;
	}

	changeActiveFiltersStatus() {
		if (this.anyActiveFilters) {
			this.anyActiveFilters = !this.anyActiveFilters;
			this.dataGrid.instance.clearFilter();
			this.ScopeList = [];
			this.gridFilterState = null;
			this.headerFiltersState = {};
			this.filterRowState = {};

			this.products = [...this.tableValuesDataSource];
			this.getSearchDataSource('', false);
		}
	}

	rowButtonClicked(e, data) {
		e.event.stopPropagation();

		window.open('forecast/deep-dive-new?id=' + UtilsService.getURLHelper(data.data.ForecastObjectClientId), '_self');
	}

	saveAllChanges() {
		this.dataGrid.instance.saveEditData().then(() => {
			if (this.unsavedChanges) {
				this.isLoading = true;
				this.forecastService.updateOverviewTableData(this.changedFcTableRecords, { showLoadingIndicator: false }).subscribe(() => {
					this.showInfoPopup = true;
					this.infoPopupMessage = 'Changes Saved Successfully!';
					this.infPopupTitle = 'Saved';
					this.unsavedChanges = false;
					this.changedFcTableRecords = [];

					if (this.dataGrid && this.dataGrid.instance) {
						//this.gridFilterState = this.dataGrid.instance.getCombinedFilter();
						this.filterRowState = {};
						this.headerFiltersState = {};

						this.dataGrid.instance.getVisibleColumns().forEach((col: any) => {
							if (col.dataField) {
								if (col.filterValue) {
									this.filterRowState[col.dataField] = {
										filterValue: col.filterValue,
									};
								}
								if (col.filterValues && col.filterValues.length > 0) {
									this.headerFiltersState[col.dataField] = [...col.filterValues];
								}
							}
						});
					}

					this.getOverviewTableData('reload');
					this.LoadDeepDive('reload');
					this.isLoading = false;

					setTimeout(() => {

						this.changeInfoPopupStatus();

					}, 3000);

				},
					(error) => {
						console.error('Error saving changes:', error);
						this.showInfoPopup = true;
						this.infoPopupMessage = 'Failed to save changes. Please try again.';
						this.infPopupTitle = 'Error';
						this.isLoading = false;

						setTimeout(() => {
							this.changeInfoPopupStatus();
						}, 3000);
					}
				);
			} else {
				this.showInfoPopup = true;
				this.infoPopupMessage = 'No changes have been done yet.';
				this.infPopupTitle = 'Warning';

				setTimeout(() => {
					this.changeInfoPopupStatus();
				}, 3000);
			}
		}).catch((error: any) => {
			console.log('Error saving changes:', error);
		});
	}

	undoAllChanges() {
		if (this.unsavedChanges) {
			this.dataGrid.instance.beginCustomLoading('Reverting changes');
			this.dataGrid.instance.closeEditCell();
			this.isLoading = true;
			if (this.dataGrid?.instance) {
				// this.gridFilterState = this.dataGrid.instance.getCombinedFilter();
				this.filterRowState = {};
				this.headerFiltersState = {};
				this.dataGrid.instance.getVisibleColumns().forEach((col: any) => {
					if (col.dataField) {
						if (col.filterValue) {
							this.filterRowState[col.dataField] = {
								filterValue: col.filterValue,
							};
						}

						if (col.filterValues && col.filterValues.length > 0) {
							this.headerFiltersState[col.dataField] = [
								...col.filterValues,
							];
						}
					}
				});
			}
			this.getOverviewTableData('load');
			this.unsavedChanges = false;
			this.changedFcTableRecords = [];
			this.dataGrid.instance.endCustomLoading();
		} else {
			this.showInfoPopup = true;
			this.infoPopupMessage = 'No changes have been done yet.';
			this.infPopupTitle = 'Warning';

			setTimeout(() => {
				this.changeInfoPopupStatus();
			}, 3000);
		}
	}

	deleteSelectedRecords() {
		this.forecastService.deleteOverviewTableData(this.selectedFcTableRecords, { showLoadingIndicator: false }).subscribe(() => {
			this.getOverviewTableData('load');
			this.showInfoPopup = true;
			this.infoPopupMessage = 'Tasks deleted successfully!';
			this.infPopupTitle = 'Deleted';
			this.selectedFcTableRecords = [];

			setTimeout(() => {
				this.changeInfoPopupStatus();
				window.location.reload();
			}, 3000);
		});
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	onEditorPreparing(event: any) {
		if (event.parentType === "dataRow" && event.dataField) {

			if (event.editorOptions) {
				const originalOnValueChanged = event.editorOptions.onValueChanged;

				event.editorOptions.onValueChanged = (args: any) => {
					this.handleValueChange(event, args.value);

					// Call original handler if present
					if (originalOnValueChanged) {
						originalOnValueChanged(args);
					}
				};
			}
		}
	}

	onEditorPrepared(event: any) {
		if (event.parentType === "dataRow" && event.dataField) {
			if (event.dataField === 'IssueResponse') {
				const originalValue = event.row.data[event.dataField];
				event.editorElement.addEventListener("input", this.debounce((e: Event) => {
					const newValue = (e.target as HTMLInputElement).value;
					const isValid = this.issueResponsesDataSource.some((item: any) => item === newValue);
					if (!isValid) {
						if (event.target as HTMLInputElement) {
							(event.target as HTMLInputElement).value = originalValue;
						}
					}
				}, 300));
			}
			else if (event.dataField === 'PermanentComment') {
				event.editorElement.addEventListener("input", this.debounce((e: Event) => {
					const newValue = (e.target as HTMLInputElement).value;
					this.handleValueChange(event, newValue);
				}, 300));
			}
		}
	}

	private debounce(func: Function, wait: number) {
		let timeout: any;
		return function (...args: any) {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), wait);
		};
	}

	handleValueChange(event: any, newValue: any) {
		if (newValue !== event.row.data[event.dataField]) {
			this.unsavedChanges = true;
			// Commit the value to the grid's data source
			event.setValue(newValue); // Required for grid to track the change
			// this.dataGrid.instance.saveEditData();
		}
	}

	onRowUpdating(e) {
		const updatedRow = { ...e.oldData, ...e.newData };
		this.unsavedChanges = true;
		this.addOrReplace(updatedRow);
	}

	changeInfoPopupStatus() {
		this.showInfoPopup = false;
		this.infoPopupMessage = '';
		this.infPopupTitle = '';
	}

	proceedingInfoPopup = false;
	changeProceedingForecastInfoPopupStatus() {
		this.proceedingInfoPopup = false;
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		const curFilter = evt.component.getCombinedFilter();

		if (curFilter) {
			this.anyActiveFilters = true;
		} else {
			this.anyActiveFilters = false;
		}

		//let $this = this;
		// setTimeout(function () {
		// 	let gridData = new DataSource(
		// 		<Options>
		// 		{
		// 			store: $this.dataGrid.dataSource,
		// 			paginate: false
		// 		}
		// 	);


		// 	//Getting all Filtering
		// 	let filterExpr = evt.component.getCombinedFilter();
		// 	if (filterExpr != null) {
		// 		gridData.filter(filterExpr);
		// 	}
		// 	//Getting all sorting
		// 	let sortingExpres = evt.component.getDataSource().sort();
		// 	if (sortingExpres != null) {
		// 		gridData.sort(sortingExpres);
		// 	}

		// 	gridData.load().then((result) => {
		// 		$this.products = result.map(product => product);
		// 		$this.autoCompleteProductDataSource = $this.products.map(product => product.productId = product.ForecastObjectClientId);
		// 	});

		// }, 2000);

		// if ($this.filterRowState) {
		// 	Object.keys($this.filterRowState).forEach(field => {
		// 		const filter = $this.filterRowState[field];
		// 		evt.component.columnOption(field, {
		// 			filterValue: filter.filterValue
		// 		});
		// 	});
		// }

		// if ($this.headerFiltersState && Object.keys($this.headerFiltersState).length > 0) {
		// 	Object.keys($this.headerFiltersState).forEach(field => {
		// 		const filterValues = $this.headerFiltersState[field];
		// 		if (filterValues && filterValues.length > 0) {
		// 			evt.component.columnOption(field, {
		// 				filterValues: [...filterValues]
		// 			});
		// 		}
		// 	});
		// }

		if (this.isEnableDeepDiveDuplicate) {
			let duplicateIds = this.tableValuesDataSource
				.map(e => e['ForecastObjectClientId'])
				.map((e, i, final) => final.indexOf(e) !== i && i)
				.filter(obj => this.tableValuesDataSource[obj])
				.map(e => this.tableValuesDataSource[e]["id"])
			if (duplicateIds != null && duplicateIds.length > 0) {
				let unique = this.tableValuesDataSource
					.map(e => e['ForecastObjectClientId'])
					.map((e, i, final) => final.indexOf(e) === i && i)
					.filter(obj => this.tableValuesDataSource[obj])
					.map(e => this.tableValuesDataSource[e]);
				if (unique != null && unique.length > 0) {
					this.tableValuesDataSource = unique;
				}
			}
		}

		this.dxDataGridOperator.updateRowCount(evt.component);

		setTimeout(() => {
			this.updateAutocompleteFromGrid(evt.component);
		}, 200);

		//localStorage.setItem('grid-state-fc-deep', JSON.stringify(this.dataGrid.instance.state()));
	}

	private initProductId(type) {
		this.route.paramMap.subscribe(
			() => {
				const value = this.route.snapshot.queryParamMap.get("id");
				this.ForecastObjectClientID = value ? value : null;
				this.LoadDeepDive(type);
			});
	}

	isNextPreDisableOnNext: boolean = false;

	private LoadDeepDive(loadType) {
		this.isNextPreDisableOnNext = false;
		this.forecastService
			.GetDeepDiveDataNew(
				this.ForecastObjectClientID, this.type, { showLoadingIndicator: false }).subscribe(data => {

					if (data) {
						if (data.flags != null && data.flags.flag == 0) {
							AppDevNotifyComponent.ErrorMessage(data.flags.msg);
						}
						this.forecastChartCaption = data.forecastChartCaption;
						this.forecastDevelopmentChartSource = data.forecastDevelopmentChart;

						this.seasonalityChartDataSource = data.forecastSeasonalityChart;


						this.masterTableDataSource = data.forecastMasterTableData;
						this.yearOnYearChartDataSource = [];
						this.CurrentValidationData = data.forecastCurrentValidationData;
						this.FieldDynamicObjectData = data.forecastFieldObejctData;
						this.deepdiveNewFieldCaption = data.deepdiveNewFieldCaption;

						if (this.FieldDynamicObjectData != null && this.FieldDynamicObjectData.roundOff != null) {
							this.RoundOffNumber = this.FieldDynamicObjectData.roundOff;
						}

						if (this.FieldDynamicObjectData != null && this.FieldDynamicObjectData.displayMinRoundingBelowNumberFc != null) {
							this.DisplayMinRoundingBelowNumberFc = this.FieldDynamicObjectData.displayMinRoundingBelowNumberFc;
						}

						if (this.FieldDynamicObjectData != null && this.FieldDynamicObjectData.displayMinRoundingPlacesFc != null) {
							this.DisplayMinRoundingPlacesFc = this.FieldDynamicObjectData.displayMinRoundingPlacesFc;
						}

						if (this.FieldDynamicObjectData != null && this.FieldDynamicObjectData.multipleFactor != null) {
							this.MultipleFactor = this.FieldDynamicObjectData.multipleFactor;
						}
						if (this.FieldDynamicObjectData != null && this.FieldDynamicObjectData.forecastObjectProductImageHeight != null) {
							this.ProductImageHeight = this.FieldDynamicObjectData.forecastObjectProductImageHeight;
						}
						if (this.FieldDynamicObjectData != null && this.FieldDynamicObjectData.forecastObjectProductImagePath != null) {
							this.ProductImagePath = this.FieldDynamicObjectData.forecastObjectProductImagePath;
						}
						if (this.FieldDynamicObjectData != null && this.FieldDynamicObjectData.forecastObjectProductImageWidth != null) {
							this.ProductImageWidth = this.FieldDynamicObjectData.forecastObjectProductImageWidth;
						}

						let forecastElementNames = data.forecastElementNames;
						this.Updateesponsdata.ClientResponse = '';
						this.Updateesponsdata.ClientComment = null;

						if (data.forecastCurrentValidationData != null && data.forecastCurrentValidationData.clientcomment != null) {
							this.Updateesponsdata.ClientComment = data.forecastCurrentValidationData.clientcomment;
						}

						if (data.forecastCurrentValidationData == null || data.forecastCurrentValidationData.clientcomment == '') {
							this.Updateesponsdata.ClientComment = null;
						}
						this.settingValue = data.settingValue;

						if (data.forecastCurrentValidationData != null) {
							this.Updateesponsdata.ClientResponse = data.forecastCurrentValidationData.clientResponse;
							this.Updateesponsdata.PermanentComment = data.forecastCurrentValidationData.permanentComment;
							this.Updateesponsdata.ClientOtherComment = data.forecastCurrentValidationData.clientcomment;
						}
						if (this.FieldDynamicObjectData != null) {
							if (this.dxForecastDevelopmentChart) {
								this.dxForecastDevelopmentChart.title = {
									text: (this.FieldDynamicObjectData.periodName == "YearWeek" ? "Weekly" : "Monthly"),
									horizontalAlignment: 'center'
								};
							}
							this.mainchartTitle = this.FieldDynamicObjectData.periodName == "YearWeek" ? "Weekly" : "Monthly";
						}

						this.LoadCommentLogic();
						if (forecastElementNames != null && forecastElementNames.length > 0) {
							this.forecastElementBasicNames = forecastElementNames.filter(function (x) {
								return (x.forecastElementType == 'Basic');
							});
						}
						else {
						}

						// //add on data
						if (forecastElementNames != null && forecastElementNames.length > 0) {
							this.forecastElementAddonsNames = forecastElementNames.filter(function (x) {
								return (x.forecastElementType == 'AddOn');
							});
						}

						this.forecastElementBasicData = data.forecastElementData;

						for (let i = 0; i < this.forecastElementBasicData.length; i++) {
							this.forecastElementBasicData[i].basic1 = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(this.forecastElementBasicData[i].basic1, this.RoundOffNumber, this.DisplayMinRoundingBelowNumberFc, this.DisplayMinRoundingPlacesFc);
							this.forecastElementBasicData[i].basic2 = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(this.forecastElementBasicData[i].basic2, this.RoundOffNumber, this.DisplayMinRoundingBelowNumberFc, this.DisplayMinRoundingPlacesFc);
							this.forecastElementBasicData[i].basic3 = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(this.forecastElementBasicData[i].basic3, this.RoundOffNumber, this.DisplayMinRoundingBelowNumberFc, this.DisplayMinRoundingPlacesFc);
							this.forecastElementBasicData[i].addOn1 = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(this.forecastElementBasicData[i].addOn1, this.RoundOffNumber, this.DisplayMinRoundingBelowNumberFc, this.DisplayMinRoundingPlacesFc);
							this.forecastElementBasicData[i].addOn2 = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(this.forecastElementBasicData[i].addOn2, this.RoundOffNumber, this.DisplayMinRoundingBelowNumberFc, this.DisplayMinRoundingPlacesFc);
							this.forecastElementBasicData[i].addOn3 = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(this.forecastElementBasicData[i].addOn3, this.RoundOffNumber, this.DisplayMinRoundingBelowNumberFc, this.DisplayMinRoundingPlacesFc);
							this.forecastElementBasicData[i].addOn4 = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(this.forecastElementBasicData[i].addOn4, this.RoundOffNumber, this.DisplayMinRoundingBelowNumberFc, this.DisplayMinRoundingPlacesFc);
							this.forecastElementBasicData[i].addOn5 = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(this.forecastElementBasicData[i].addOn5, this.RoundOffNumber, this.DisplayMinRoundingBelowNumberFc, this.DisplayMinRoundingPlacesFc);
						}

						if (this.FieldDynamicObjectData.headerName != null) {
							this.ForecastObjectClientID = this.FieldDynamicObjectData.headerName;
							this.currentValidationId = this.FieldDynamicObjectData.currentValidationId;
						}
						//adding for year on year chart data need to be serials
						this.yearOnYearChartDataSource = data.forecastYearOnYearChart;

						this.forecastElementBasicOldData = JSON.parse(JSON.stringify(data.forecastElementData));

					}
					else {
						//setting data to null if no data found
						this.forecastDevelopmentChartSource = [];
						this.yearOnYearChartDataSource = [];
						this.seasonalityChartDataSource = [];
					}

					if (loadType == 'pageload') {
						if (data && data.forecastFieldObejctData && data.forecastFieldObejctData.headerName) {
							this.selectedItem = data.forecastFieldObejctData.headerName;
						}
						this.getOverviewTableData('load');
					}

					//key figure changes for update fields
					let keyFigureSettings = this.settingValue;
					keyFigureSettings.forEach(element => {
						let keyfigreChnge = this.ForecastKeyFigures.find(x => x.FieldName.toLowerCase() == element.name.toLowerCase());
						if (element.value.toLowerCase().trim() == "yes" && keyfigreChnge != null && keyfigreChnge != undefined) {
							keyfigreChnge.Visible = true;
						}

						let keyfigreCaption = this.ForecastKeyFigures.find(x => x.ColumnName.toLowerCase() == element.name.toLowerCase());
						if (keyfigreCaption != null && keyfigreCaption != undefined) {
							keyfigreCaption.Caption = element.value;
						}

						let keyfigreEditable = this.ForecastKeyFigures.find(x => "editable" + x.ColumnName.toLowerCase() == element.name.toLowerCase());
						if (element.value.toLowerCase().trim() == "yes" && keyfigreEditable != null && keyfigreEditable != undefined) {
							keyfigreEditable.Editable = true;
						}

					});

					this.handleChartsAndLegends();
					setTimeout(() => {
						this.isNextPreDisableOnNext = false;
					}, 2000);
				}, error => {
					console.log(error, "test error");
					this.isNextPreDisableOnNext = false;
				});

	}
	LoadCommentLogic() {
		if (this.forecastCommentData != null && this.forecastCommentData.length > 0
			&& this.Updateesponsdata.ClientComment != null) {
			let item = this.forecastCommentData.filter(x => x.ListElement.toLowerCase() == this.Updateesponsdata.ClientComment.toLowerCase());
			if (item == null || item.length == 0) {
				this.Updateesponsdata.ClientComment = this.ClientResponsLogic;
			}
		}
	}

	private removeThousandSeparator = (number) => number.toString().replace(/,(?=\d{3})/g, '');

	OnFcAjstBasicChange = function (MainLoopItem, e, action) {
		let $this = this;
		let Data: number = MainLoopItem.basic1;
		MainLoopItem.fcAjstBasicSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(Data, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
		$this.forecastElementBasicNames.forEach((element) => {
			if (element.includeInFinalForecast3) {
				if (element != null && MainLoopItem[element.forecastElementFieldName] != null) {
					Data = +this.removeThousandSeparator(MainLoopItem[element.forecastElementFieldName]);
					MainLoopItem.touched = true;
				}
				MainLoopItem.fcAjstBasicSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(Data, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
			}
		});
		$this.SumTotalForecaste(MainLoopItem, e, action);
	}

	SumTotalForecaste = function (MainLoopItem, e, action) {
		let $this = this;
		MainLoopItem.fcTotalSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(MainLoopItem.basic1, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
		if (isNaN(MainLoopItem.fcTotalSum)) {
			MainLoopItem.fcTotalSum = 0;
		}
		MainLoopItem.fcAjstBasicSum = parseFloat(MainLoopItem.fcAjstBasicSum);
		if (isNaN(MainLoopItem.fcAjstBasicSum)) {
			MainLoopItem.fcAjstBasicSum = 0;
		}

		if (MainLoopItem.fcAjstBasicSum != null) {
			MainLoopItem.fcTotalSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(MainLoopItem.fcAjstBasicSum, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
		}

		$this.forecastElementAddonsNames.forEach((element) => {
			if (element != null && MainLoopItem[element.forecastElementFieldName] != null && element.includeInFinalForecast3) {
				MainLoopItem.fcTotalSum += UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(+this.removeThousandSeparator(MainLoopItem[element.forecastElementFieldName]), $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
			}
		});

		MainLoopItem.fcTotalSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(MainLoopItem.fcTotalSum, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);

		if (action == 'onContentReady' && $this.forecastElementBasicData != undefined) {
			$this.forecastElementBasicDataCopy = JSON.parse(JSON.stringify($this.forecastElementBasicData));
		}
		// if ($this.activeService != undefined) {
		// 	$this.activeService.setForecastDeepDive($this.CheckContainChanges());
		// }
	}


	private LoadDefaultDdl() {

		this.forecastService
			.GetCommonSelection("ClientComment", "ClientResponse", { showLoadingIndicator: false }).toPromise().then(data => {

				if (data != null && data[0] != null) {
					this.forecastCommentData = data[0];
				}

				if (data != null && data[1] != null) {
					this.forecastClientResponsData = data[1];
					this.LoadCommentLogic();
				}

			}).catch((err) => {
				console.log(err, "test error");
			});

	}

	//#region Chart Settings and funcation

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		if (info && info.originalValue && this.DisplayMinRoundingBelowNumberFc > info.originalValue) {

			return DevTooltipCustComponent.customizeTooltip(info, (this.FieldDynamicObjectData.periodName == "YearWeek" ? "Weekly" : "Monthly"), "", "", true, this.DisplayMinRoundingPlacesFc);

		}
		return DevTooltipCustComponent.customizeTooltip(info, (this.FieldDynamicObjectData.periodName == "YearWeek" ? "Weekly" : "Monthly"), "", "");
	}

	customizeValuesAxis = (info: any) => {
		let values = 0;
		if (!isNaN(info.value)) {
			values = Number(info.value);
		}
		if (this.DisplayMinRoundingBelowNumberFc > values) {
			return UtilsService.FormatNumberWithDecimalPlacesNew(values, this.DisplayMinRoundingPlacesFc);
		}
		return UtilsService.FormatNumberWithDecimalPlacesNew(values, this.RoundOffNumber);

	}
	//adding percentage symbol in seasonality
	customizeText = (info: any) => {
		return Math.round(info.value).toLocaleString() + '%';
	}

	// Hide and show series on click
	public onLegendClick(evt: LegendClickEvent) {
		const series = evt.target;

		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
		}

		this.loadLengendToShare();
	}
	//#endregion

	//#region DeepDive List

	changeProductId(item: any) {
		if (item != null) {
			if (!this.CheckContainChanges() && !confirm(this.activeService.getConfirmMessage())) {
				return
			}
			let productId = item.data.ForecastObjectClientId ? item.data.ForecastObjectClientId : '';
			this.selectedItem = productId;
			this.location.go(`forecast/deep-dive-new?id=${UtilsService.getURLHelper(productId)}`);
			this.ForecastObjectClientID = productId;
			this.LoadDeepDive('reload');
			setTimeout(() => this.autocomplete.setSelectedItem(productId));
		}

		this.scrollTop();
	}

	//#endregion


	onGridOptionChanged(evt: any) {
		const name = evt?.fullName || evt?.name || '';

		const affectsFilter =
			name === 'filterValue' ||
			name === 'filterValues' ||
			name === 'filterPanel.filterEnabled' ||
			name === 'searchPanel.text' ||
			(name.startsWith('columns[') && (name.endsWith('filterValue') || name.endsWith('filterValues')));

		const affectsSort = 
			name === 'sortOrder' ||
			name === 'sortIndex' ||
			(name.startsWith('columns[') && (name.endsWith('sortOrder') || name.endsWith('sortIndex')));

		if (affectsFilter || affectsSort) {
			this.updateAutocompleteFromGrid(evt.component);
			const curFilter = evt.component.getCombinedFilter();
			this.anyActiveFilters = !!curFilter;
		}
	}

	getSearchDataSource(value: string, filterByValue: boolean) {
		let source = this.products.map(product => product.productId = product.ForecastObjectClientId);
		if (filterByValue) {
			source = source.filter(product => product.indexOf(value) > -1);
		}
		this.autoCompleteProductDataSource = source;
	}

	private updateAutocompleteFromGrid(grid: any): void {
		if (!grid || !grid.getDataSource) return;
		const filterExpr = grid.getCombinedFilter(true);
		const sortExpr = grid.getDataSource().sort();
		const ds = grid.getDataSource();
		
		ds.store().load({ 
			filter: filterExpr,
			sort: sortExpr // Include sort order
		}).then((data: any[]) => {
			this.products = data || [];
			this.getSearchDataSource('', false);
		});
	}



	getProductData(item?: any) {
		console.warn(item, this.selectedItem);
		if (item) {
			// if (this.CheckContainChanges() || this.IsSaveNext) {
			// 	this.loadProduct(item);
			// }
			// else if (confirm(this.activeService.getConfirmMessage())) {
			this.loadProduct(item);
			// }
		}
	}

	onNextPrevConfirm = (): boolean => {
		if (!this.CheckContainChanges() && !confirm(this.activeService.getConfirmMessage())) {
			return false
		} else {
			return true
		}
	}

	public autoCompleteProductChange(productId: string) {

		this.selectedItem = productId;

		this.getProductData(productId);
	}

	loadProduct(item) {
		this.ForecastObjectClientID = item ? item : '';
		this.location.go(`forecast/deep-dive-new?id=${UtilsService.getURLHelper(item)}`);

		this.LoadDeepDive('reload');

		setTimeout(() => this.autocomplete.setSelectedItem(item));

		this.scrollTop();
	}

	scrollTop() {
		const el = document.getElementById('anchor');
		setTimeout(() => {
			if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
		}, 1);
	}

	SaveComment = () => {

		this.Updateesponsdata.ClientResponse = '';
		this.Updateesponsdata.ClientComment = "";
		this.Updateesponsdata.ClientOtherComment = "";
		this.Updateesponsdata.ForecastObjectClientId = this.ForecastObjectClientID;


		if (this.forecastResponse.value) {
			this.Updateesponsdata.ClientResponse = this.forecastResponse.value;
		}

		if (this.forecastComment.value) {
			this.Updateesponsdata.ClientComment = this.forecastComment.value;
		}
		if (this.forecastClientOtherComment && this.forecastClientOtherComment.value) {
			this.Updateesponsdata.ClientOtherComment = this.forecastClientOtherComment.value;
		}


		this.forecastService.UpdateForecastComment(this.Updateesponsdata, { showLoadingIndicator: false }).subscribe(res => {
			for (let index = 0; index < res.returnFlag.length; index++) {
				if (res.returnFlag[index].flag > 0) {

					this.showInfoPopup = true;
					this.infoPopupMessage = 'Changes Saved Successfully!';
					this.infPopupTitle = 'Saved';

					this.getOverviewTableData('reload');
					this.LoadDeepDive('reload');
					setTimeout(() => {
						this.changeInfoPopupStatus();

					}, 3000);
				}
				else {
					AppDevNotifyComponent.ErrorMessage(res.returnFlag[index].msg);
				}

			}
		}
			, () => {
				AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");
			}
		);
	}

	UploadChanges = () => {
		this.UploadForestElemt = new ForecastElementUpdateNewData();
		this.UploadForestElemt.action = 'NormalUpdateWithComment';
		this.UploadForestElemt.multipleFactor = this.MultipleFactor;
		this.UploadForestElemt.ForecastObjectId = this.FieldDynamicObjectData.forecastObjectId;;
		this.UploadForestElemt.forecastData = [];
		this.UploadForestElemt.KeyFigureData = [];
		this.UploadForestElemt.KeyFigureFields = [];

		for (let dataItem of this.forecastElementBasicData) {
			this.UploadForestElemt.forecastData.push({
				period: dataItem.period,
				entryUser: '',
				ElemntComment: dataItem.elemntComment,
				basic1: dataItem.basic1,
				basic2: dataItem.basic2,
				basic3: dataItem.basic3,
				addOn1: dataItem.addOn1,
				addOn2: dataItem.addOn2,
				addOn3: dataItem.addOn3,
				addOn4: dataItem.addOn4,
				addOn5: dataItem.addOn5,
				commercialObjectId: dataItem.commercialObjectId
			});
			this.UploadForestElemt.KeyFigureData.push({
				KeyFigure1: dataItem.ForecastKeyFigure1,
				KeyFigure2: dataItem.ForecastKeyFigure2,
				KeyFigure3: dataItem.ForecastKeyFigure3,
				KeyFigure4: dataItem.ForecastKeyFigure4,
				KeyFigure5: dataItem.ForecastKeyFigure5,
				KeyFigure6: dataItem.ForecastKeyFigure6,
				KeyFigure7: dataItem.ForecastKeyFigure7,
				KeyFigure8: dataItem.ForecastKeyFigure8,
				KeyFigure9: dataItem.ForecastKeyFigure9,
				KeyFigure10: dataItem.ForecastKeyFigure10,
				period: dataItem.period,
				ForecastObjectId: this.UploadForestElemt.ForecastObjectId,
				commercialObjectId: dataItem.commercialObjectId
			});
		}

		this.ForecastKeyFigures.forEach(element => {
			if (element.Visible == true) {
				this.UploadForestElemt.KeyFigureFields.push({ KeyPair: element.ColumnName, ValuePair: element.ColumnName });
			}
		});

		let IsNegativeForecast = false;
		this.forecastElementBasicData.forEach(element => {
			if (element.fcTotalSum < 0) {
				IsNegativeForecast = true;
			}
		});

		//start comment update

		this.Updateesponsdata.ClientResponse = '';
		this.Updateesponsdata.ClientComment = "";
		this.Updateesponsdata.ClientOtherComment = "";
		this.Updateesponsdata.ForecastObjectClientId = this.ForecastObjectClientID;


		if (this.forecastResponse.value) {
			this.Updateesponsdata.ClientResponse = this.forecastResponse.value;
		}

		if (this.forecastComment.value) {
			this.Updateesponsdata.ClientComment = this.forecastComment.value;
		}
		if (this.forecastClientOtherComment && this.forecastClientOtherComment.value) {
			this.Updateesponsdata.ClientOtherComment = this.forecastClientOtherComment.value;
		}
		this.UploadForestElemt.comment = this.Updateesponsdata;
		//end comment update

		if (IsNegativeForecast) {
			this.proceedingInfoPopup = true;
		} else {
			this.UploadForecastChanges();
		}
	}

	UploadForecastChanges = () => {
		this.proceedingInfoPopup = false;
		this.forecastService.UpdateForecastBasicManualAdjustmentNew(this.UploadForestElemt, { showLoadingIndicator: false }).subscribe(res => {
			if (this.IsSaveNext == false) {
				this.LoadDeepDive('reload');

			}
			for (let index = 0; index < res.returnFlag.length; index++) {
				if (res.returnFlag[index].flag > 0) {
					AppDevNotifyComponent.SuccesMessage(res.returnFlag[index].msg);
				}
				else {
					AppDevNotifyComponent.ErrorMessage(res.returnFlag[index].msg)
				}
			}

			setTimeout(() => { this.getOverviewTableDataById('ByIdReload'); }, 1000);
		}
			, () => {
				AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");
			}
		);
	}

	HideNegativePopup() {
		this.proceedingInfoPopup = false;
	}

	onCommentChanged() {
		if (this.forecastComment.value == this.ClientResponsLogic) {
			if (this.forecastClientOtherComment && this.forecastClientOtherComment.value) {
				this.forecastClientOtherComment.value = '';
			}
		}
	}

	//window resize function  refresh all charts
	onResize() {

	}

	getMarkerPath(item) {

		return UtilsService.getlegendMarkerPathDynamic(item, 'deepdive', GlobalConstants.SvgLinSettingsCollection.defaultSettingsNew);
	}


	curentusername: string = "";
	showInfo(item) {
		this.popupVisible = true;
		this.currentComment.Comment = item.elemntComment;
		this.currentComment.Period = item.period;
		this.lastUpdatedAt = null;
		if (item.UpdatedOn != null && item.UpdatedOn != undefined) {
			this.lastUpdatedAt = item.UpdatedOn;
		}
		this.curentusername = null;
		if (item.entryUser != null && item.entryUser != undefined) {
			this.curentusername = item.entryUser;
		}
	}

	UpdateForecastCommentInfo(action) {
		this.popupVisible = false;
		if (action == 'Save') {
			this.forecastElementBasicData.filter(x => {
				if (x.period == this.currentComment.Period) {
					x.elemntComment = this.currentComment.Comment;
				}
				return x;
			});
		}
		this.currentComment.Comment = "";
		this.currentComment.Period = 0;
	}



	public formatNumber(num: number): string {
		return Globalize.formatNumber(num | 0);
	}


	ForecastKeyFiguresFilter() {
		return this.ForecastKeyFigures.filter(x => x.Visible == true);
	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	EnableBasicFcDeepDive = true;
	isEnableDeepDiveDuplicate = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotForecastDeepDive", { showLoadingIndicator: false }).subscribe(result => {
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipForecastDeepDive != null
				&& result[0].defaultSelectionTooltipForecastDeepDive.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipForecastDeepDive != null
				&& result[0].enableDisableTooltipForecastDeepDive.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

			if (result != null && result.length > 0 && result[0].deepDiveAdjustMultipleFactorTitle != null) {
				this.deepDiveAdjustMultipleFactorTitle = result[0].deepDiveAdjustMultipleFactorTitle;
			}

			if (result != null && result.length > 0 && result[0].deepDiveRemoveDuplicate != null && result[0].deepDiveRemoveDuplicate.toLowerCase() == "yes") {
				this.isEnableDeepDiveDuplicate = true;
			}

			if (result != null && result.length > 0 && result[0].enableBasicFcDeepDive != null
				&& result[0].enableBasicFcDeepDive.toLowerCase() == "no") {
				this.EnableBasicFcDeepDive = false;
			}

		}, err => {
			console.log(err);
		});
	}

	IsSaveNext: boolean = false;
	IsSaveItem: any;

	SaveProductNext(item?: any) {
		this.IsSaveNext = true;
		this.IsSaveItem = item;
		this.UploadChanges();
	}

	confirmUnsaveChanges:any = false
	onJumpItemSelect = () :boolean =>{
		if(!this.CheckContainChanges() && !confirm(this.activeService.getConfirmMessage())){
			return false
		}else{
			return true
		}
	}

	CheckContainChanges(): boolean {
		return JSON.stringify(this.forecastElementBasicData) == JSON.stringify(this.forecastElementBasicDataCopy);
	}

	ScopeList = [];

	loadLengendToShare() {
		let seriesValues = { ForecastDevelopmentChart: [], YearOnYearChart: [], SeasonalityChart: [], ScopeList: [] };
		if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.instance != null
			&& this.dxForecastDevelopmentChart.instance.getAllSeries() != null) {
			this.dxForecastDevelopmentChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.ForecastDevelopmentChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.instance != null
			&& this.dxYearOnYearChart.instance.getAllSeries() != null) {
			this.dxYearOnYearChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.YearOnYearChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.instance != null
			&& this.dxSeasonalityChart.instance.getAllSeries() != null) {
			this.dxSeasonalityChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.SeasonalityChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}
		seriesValues.ScopeList = this.ScopeList;
	}

	OnFcAjstBasicFocusIn(e) {
		let inputEl = e.element.querySelector(".dx-texteditor-input");
		inputEl.selectionStart = 0;
		inputEl.selectionEnd = inputEl.value.length;
	}
	deepDiveAdjustMultipleFactorTitle = "";
	onClick(event) {
		let target = event.target || event.srcElement || event.currentTarget;
		let srcAttr = target.attributes.src;
		this.imgSrc = srcAttr.nodeValue;
		this.ImgTitle = target.title;
		this.ImageInfoPopup = true
	}

	formatCurrcy = function (values) {
		if (this.DisplayMinRoundingBelowNumberFc > values) {
			return UtilsService.FormatNumberWithDecimalPlacesNew(values, this.DisplayMinRoundingPlacesFc);
		}
		return UtilsService.FormatNumberWithDecimalPlacesNew(values, this.RoundOffNumber);
	}

	restoreFilterUIState($this) {
		if (!$this.dataGrid || !$this.dataGrid.instance) return;

		// Use beginUpdate/endUpdate to batch column changes
		$this.dataGrid.instance.beginUpdate();

		try {
			// Restore filter row values
			if($this.filterRowState){
				Object.keys($this.filterRowState).forEach(field => {
					const filter = $this.filterRowState[field];
					$this.dataGrid.instance.columnOption(field, 'filterValue', filter.filterValue);
				});
			}
			// Restore header filter values
			if($this.headerFiltersState){
				Object.keys($this.headerFiltersState).forEach(field => {
					const filterValues = $this.headerFiltersState[field];
					if (filterValues && filterValues.length > 0) {
						$this.dataGrid.instance.columnOption(field, 'filterValues', filterValues);					
					}
				});
			}
			// Restore sort order
			// Object.keys(this.sortOrderState).forEach(field => {
			// 	const fsortOrderalues = this.sortOrderState[field];
			// 	console.log('fsortOrderalues', fsortOrderalues);
			// 	this.dataGrid.instance.columnOption(field, 'sortOrder', fsortOrderalues);
			// 	this.dataGrid.instance.columnOption(field, 'sortIndex', 0);
			// });

		} finally {
			$this.dataGrid.instance.endUpdate();
		}

		// Clear the states - use empty objects instead of arrays
		$this.filterRowState = {};
		$this.headerFiltersState = {};
	}
}
